import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-network-share-details',
  templateUrl: './network-share-details.component.html',
  styleUrls: ['./network-share-details.component.scss'],
  standalone: false,
})
export class NetworkShareDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
